import React, { useEffect, useState, useRef } from 'react'
import Helpers from '../../Helpers/Helpers'
import { Link } from 'react-router-dom'
import moment from "moment"
import Slider from 'react-slick'
import './mobile.css'

const LatestPosts = () => {
    const [loading, setLoading] = useState(false)
    const [posts, setPosts] = useState([])
    const helpers = Helpers()
    const sliderRef = useRef(null)

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await helpers.httpRequest(`/posts/?page=1&limit=8`, 'GET')

                if (response.status === 'success') {
                    const filtered=response.data
                      .filter(p=>p.status==='active' && p.show_on_homepage)
                      .sort((a,b)=>(a.homepage_order??999)-(b.homepage_order??999))
                    setPosts(filtered)
                }
            } catch (error) {
                console.error('Error fetching Posts:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    const CustomPrevArrow = ({ onClick }) => (
        <button
            className="custom-carousel-btn custom-carousel-prev"
            onClick={onClick}
            type="button"
        >
            <i className="fas fa-chevron-left"></i>
        </button>
    )

    const CustomNextArrow = ({ onClick }) => (
        <button
            className="custom-carousel-btn custom-carousel-next"
            onClick={onClick}
            type="button"
        >
            <i className="fas fa-chevron-right"></i>
        </button>
    )

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: "unslick" }
        ]
    }

    return (
        <section className="as_blog_wrapper  as_padderBottom80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <h1 className="as_heading as_heading_center">
                            Latest Articles
                        </h1>
                        {/* <p className="as_font14 as_padderTop20 as_padderBottom10">
                            It is a long established fact that a reader will be distracted by the readable content of a page
                            <br />
                            when looking at its layout. The point of using Lorem Ipsum .
                        </p> */}
                        <div className="v3_blog_wrapper position-relative">
                            <div className="row text-left d-none d-md-block">
                                <Slider {...settings} ref={sliderRef}>
                                  {posts.map(post=> (
                                    <div key={post.id} className="p-3">
                                      <div className="as_blog_box h-100">
                                        <div className="as_blog_img">
                                          <Link to={`/blogs/view/${post.id}`}>
                                            <img alt="Post" className="img-responsive" src={post.full_image} />
                                          </Link>
                                          <span className="date-ribbon">
                                            {moment(post.created_at).format('MMM DD, YYYY')}
                                          </span>
                                          <span className="view-counter">👁️ {post.views ?? 0}</span>
                                        </div>
                                        <div className="as_blog_detail">
                                          <ul>
                                            <li>
                                              <span>
                                                <img alt="" src="/assets/images/svg/user2.svg" />
                                                By - {post.userId?.name}
                                              </span>
                                            </li>
                                          </ul>
                                          <h4 className="as_subheading">
                                            <Link to={`/blogs/view/${post.id}`}>{post.title}</Link>
                                          </h4>
                                          <p className="as_font14 as_margin0">
                                            {helpers.truncateText(post.description, 20)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </Slider>
                            </div>

                            <div className="row text-left d-md-none">
                                <div className="blog-carousel w-100">
                                  {posts.map(post=> (
                                    <div key={post.id} className="blog-item">
                                      <div className="as_blog_box h-100 blog-card">
                                        <div className="as_blog_img">
                                          <Link to={`/blogs/view/${post.id}`}>
                                            <img alt="Post" className="img-responsive" src={post.full_image} />
                                          </Link>
                                          <span className="date-ribbon">
                                            {moment(post.created_at).format('MMM DD, YYYY')}
                                          </span>
                                          <span className="view-counter">👁️ {post.views ?? 0}</span>
                                        </div>
                                        <div className="as_blog_detail">
                                          <ul>
                                            <li>
                                              <span>
                                                <img alt="" src="/assets/images/svg/user2.svg" />
                                                By - {post.userId?.name}
                                              </span>
                                            </li>
                                          </ul>
                                          <h4 className="as_subheading">
                                            <Link to={`/blogs/view/${post.id}`}>{post.title}</Link>
                                          </h4>
                                          <p className="as_font14 as_margin0">
                                            {helpers.truncateText(post.description, 20)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-center as_padderTop60">
                            <Link className="as_btn" to="blogs">
                                view more
                            </Link>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LatestPosts
